import React from 'react';
import { Share, X, MoreVertical, Plus } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useIOSInstallPrompt } from '@/hooks/useIOSInstallPrompt';

const IOSInstallPrompt: React.FC = () => {
  const { showPrompt, dismissPrompt, isSafari } = useIOSInstallPrompt();

  if (!showPrompt) return null;

  return (
    <Card className="fixed top-20 left-3 right-3 z-[999] p-4 bg-charcoal border-0 shadow-2xl rounded-xl animate-fade-in">
      <div className="space-y-3">
        {/* Header with title and dismiss */}
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
              <Plus className="w-4 h-4 text-white" />
            </div>
            <p className="font-semibold text-white text-sm">
              Install forkast
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="flex-shrink-0 h-7 w-7 text-white/70 hover:text-white hover:bg-white/10 -mt-1 -mr-1"
            onClick={dismissPrompt}
            aria-label="Dismiss install prompt"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>

        {/* Step-by-step instructions */}
        <div className="space-y-2 pl-1">
          {isSafari ? (
            <>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
                <span className="text-white/80">Tap <Share className="inline w-3.5 h-3.5 text-white -mt-0.5 mx-0.5" /> <span className="text-white font-medium">Share</span> in Safari toolbar</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
                <span className="text-white/80">Scroll down, tap <span className="text-white font-medium">"Add to Home Screen"</span></span>
              </div>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
                <span className="text-white/80">Tap <span className="text-white font-medium">"Add"</span> to confirm</span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
                <span className="text-white/80">Tap <MoreVertical className="inline w-3.5 h-3.5 text-white -mt-0.5 mx-0.5" /> <span className="text-white font-medium">Menu</span> in Chrome</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
                <span className="text-white/80">Tap <span className="text-white font-medium">"Add to Home Screen"</span></span>
              </div>
              <div className="flex items-center gap-2.5 text-sm">
                <span className="w-5 h-5 rounded-full bg-white text-charcoal flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
                <span className="text-white/80">Tap <span className="text-white font-medium">"Add"</span> to confirm</span>
              </div>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export default IOSInstallPrompt;
